<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card class="px-3 py-3">
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardTitle }}</p>
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="service_type">{{ cvServiceTypeLabel }}</label><br/>
                  <select
                    id="service_type"
                    v-model="vmWrkServiceConfigFormData.service_type"
                    class="form-control"
                    required
                  >
                    <option :value="null" disabled>Select Service Type</option>
                    <option value="api">api</option>
                    <option value="DB">DB</option>
                  </select>
                </div>

                <div class="col-md-12 mb-3">
                  <label for="service_method">{{ cvServiceMethodLabel }}</label><br/>
                  <input
                    v-model="vmWrkServiceConfigFormData.service_method"
                    type="text"
                    class="form-control"
                    placeholder="E.g: post"
                    required
                  />
                </div>

                <div class="col-md-12 mb-3">
                  <label for="service_name">{{ cvServiceNameLabel }}</label><br/>
                  <input
                    v-model="vmWrkServiceConfigFormData.service_name"
                    type="text"
                    class="form-control"
                    placeholder="Enter service name"
                    required
                  />
                </div>

                <div class="col-md-12 mb-3">
                  <label for="service_activity">Service Activity</label><br/>
                  <input
                    id="service_activity"
                    v-model="vmWrkServiceConfigFormData.service_activity"
                    type="text"
                    class="form-control"
                    placeholder="E.g: /tprep_analytics_result_insights_generate"
                    required
                  />
                </div>

                <div class="col-md-12 mb-3">
                  <label for="module_name">{{ cvModuleNameLabel }}</label><br/>
                  <input
                    v-model="vmWrkServiceConfigFormData.module_name"
                    type="text"
                    class="form-control"
                    placeholder="Enter module name"
                    required
                  />
                </div>

                <div class="col-md-12 mb-3">
                  <label for="module_id">{{ cvModuleIdLabel }}</label><br/>
                  <input
                    v-model="vmWrkServiceConfigFormData.module_id"
                    type="text"
                    class="form-control"
                    placeholder="Optional (required only when tags are provided)"
                  />
                </div>

                <div class="col-md-12 mb-3">
                  <label for="service_activity_desc">{{ cvServiceActivityDescLabel }}</label><br/>
                  <b-form-textarea
                    id="service_activity_desc"
                    v-model="vmWrkServiceConfigFormData.service_activity_desc"
                    rows="4"
                    max-rows="10"
                    placeholder="Enter service activity description"
                    required
                  ></b-form-textarea>
                </div>

                <div class="col-md-12 mb-3">
                  <label for="service_activity_payload">{{ cvServiceActivityPayloadLabel }}</label><br/>
                  <b-form-textarea
                    id="service_activity_payload"
                    v-model="vmWrkServiceConfigFormData.service_activity_payload"
                    rows="4"
                    max-rows="10"
                    placeholder='JSON payload e.g. {"user_id":"optional"}'
                    required
                  ></b-form-textarea>
                </div>

                <div class="col-md-12 mb-3">
                  <label for="service_activity_tags">{{ cvServiceActivityTagsLabel }}</label><br/>
                  <input
                    v-model="vmWrkServiceConfigFormData.service_activity_tags"
                    type="text"
                    class="form-control"
                    placeholder="Optional comma-separated tags e.g. tprep,analytics,insights,generate"
                  />
                </div>

                <button
                  :disabled="cvLoadingStatus"
                  type="button"
                  class="btn btn-primary mx-2"
                  @click="wrkServiceConfigAdd()"
                >
                  {{ cvSubmitBtn }}
                </button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit"
import { wrkServiceConfigs } from "../../../FackApi/api/wrkServiceConfig.js"

export default {
  name: "wrkServiceConfigAdd",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cvCardTitle: "Add Service Configuration",
      cvSubmitBtn: "Add",
      cvServiceTypeLabel: "Service Type",
      cvServiceMethodLabel: "Service Method",
      cvServiceNameLabel: "Service Name",
      cvModuleNameLabel: "Module Name",
      cvModuleIdLabel: "Module Id",
      cvServiceActivityDescLabel: "Service Activity Description",
      cvServiceActivityPayloadLabel: "Service Activity Payload (JSON)",
      cvServiceActivityTagsLabel: "Service Activity Tags (comma-separated)",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Service Config",
      cvLoadingStatus: false,
      vmWrkServiceConfigFormData: Object.assign({}, this.initFormData())
    }
  },
  mounted () {
    socialvue.index()
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        service_type: "api",
        service_method: "",
        service_name: "",
        service_activity: "",
        module_name: "",
        module_id: null,
        service_activity_desc: "",
        service_activity_payload: "",
        service_activity_tags: ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        const d = this.vmWrkServiceConfigFormData

        if (!String(d.service_type || "").trim()) {
          this.toastMsg = "Missing service_type"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }
        if (!String(d.service_method || "").trim()) {
          this.toastMsg = "Missing service_method"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }
        if (!String(d.service_name || "").trim()) {
          this.toastMsg = "Missing service_name"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }
        if (!String(d.module_name || "").trim()) {
          this.toastMsg = "Missing module_name"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        if (!String(d.service_activity || "").trim()) {
          this.toastMsg = "Missing service_activity"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        if (!String(d.service_activity_desc || "").trim()) {
          this.toastMsg = "Missing service_activity_desc"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        if (!String(d.service_activity_payload || "").trim()) {
          this.toastMsg = "Missing service_activity_payload"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        // payload rules:
        // - API: payload must be strict JSON
        // - DB: payload can be any string (table structure)
        if (String(d.service_type || "").toUpperCase() === "API") {
          const payloadStr = String(d.service_activity_payload || "").trim()
          try {
            JSON.parse(payloadStr)
          }
          catch (e) {
            this.toastMsg = "Invalid service_activity_payload JSON. Use strict JSON."
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }

        const tagsRaw = String(d.service_activity_tags || "").trim()
        const hasTags = tagsRaw.length > 0

        const moduleIdRaw = String(d.module_id || "").trim()
        const hasModuleId = moduleIdRaw.length > 0

        if (hasTags) {
          const parts = tagsRaw.split(",").map(t => t.trim()).filter(Boolean)

          if (parts.length === 0) {
            this.toastMsg = "service_activity_tags cannot be empty when provided"
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }

          const invalidToken = parts.find(t => !/^[A-Za-z0-9_-]+$/.test(t))
          if (invalidToken) {
            this.toastMsg = "Invalid tag detected: " + invalidToken + ". Use comma-separated tags with A-Z/a-z/0-9/_/-"
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }

          d.service_activity_tags = parts.join(",")
          d.module_id = (hasModuleId ? moduleIdRaw : null)

          // We only enforce JSON parsing for API type.
          if (String(d.service_type || "").toUpperCase() === "DB") {
            // no-op: allow arbitrary DB payload string
            d.service_activity_payload = String(d.service_activity_payload || "").trim()
          }
        }
        else {
          d.service_activity_tags = null
          d.module_id = (hasModuleId ? moduleIdRaw : null)
        }

        // Normalize null-ish fields
        if (d.module_id === "" || d.module_id === undefined) d.module_id = null

        return true
      }
      catch (err) {
        console.error("validate error", err)
        this.toastMsg = "Validation failed"
        this.toastVariant = "danger"
        this.showToast = true
        return false
      }
    },
    /**
     * wrkServiceConfigAdd
     */
    async wrkServiceConfigAdd () {
      if (!this.validate()) return false

      try {
        this.cvLoadingStatus = true

        // API expects form-data keys same as backend column names
        const resp = await wrkServiceConfigs.wrkServiceConfigAdd(this, this.vmWrkServiceConfigFormData)

        if (resp && resp.resp_status) {
          this.toastMsg = "Service config added successfully"
          this.toastVariant = "success"
          this.showToast = true

          if (this.propOpenedInModal) {
            this.$emit("emitCloseWrkServiceConfigAddModal", resp.resp_data)
          }
          this.vmWrkServiceConfigFormData = Object.assign({}, this.initFormData())
          return true
        }
        else {
          this.toastMsg = resp?.resp_msg || "Failed to add service config"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }
      }
      catch (err) {
        console.error("wrkServiceConfigAdd error", err)
        this.toastMsg = "Failed to add service config"
        this.toastVariant = "danger"
        this.showToast = true
        return false
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
